module.exports = __webpack_public_path__ + "static/img/mobile-web-img-03@t.f1477be.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/mobile-web-img-03@t.png
// module id = 7NZ4
// module chunks = 0